import { render, staticRenderFns } from "./Norway.vue?vue&type=template&id=df2a6c4a&"
import script from "./Norway.vue?vue&type=script&lang=ts&"
export * from "./Norway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports